import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators, } from '@angular/forms';
import { BusinessService } from '../../../../common/services/Business.service';
import { UploadService } from '../../../../common/services/Upload.service';
import { Location } from '@angular/common';
import { Message } from 'primeng/primeng';
import { EvsAddressService } from '../../../../common/services/EvsAddress.service';
import { ToastrService } from 'ngx-toastr';
import { ImageService } from '../../../imageService';
import { environment } from '../../../../../environments/environment';
import { TranslateService } from '@ngx-translate/core';

declare var $: any;

@Component({
  selector: 'app-business-profile',
  templateUrl: 'business-profile.template.html',
  styleUrls: ['./business.css'],
  providers: [BusinessService, EvsAddressService, UploadService, ImageService],
})
export class BusinessProfileComponent implements OnInit {
  public businessForm: FormGroup;
  public reTargetForm: FormGroup
  public msgs: Message[] = [];
  public message: { class: string; content: string } = null;
  public error: string = '';
  public files: any = null;
  public messageErrorImage: string;
  public business: any = {};
  public retarget: any = {}
  public mCity: number = 0;
  public mDistrict: number = 0;
  public cities: Array<any> = [];
  public districts: Array<any> = [];
  public attachments: any[] = [];
  public filesAttach: any[] = [];
  public filesAttachName: any[] = [];
  public dataRetarget: any;
  public startRetarget: any;
  public endRetarget: any
  attachmentAvatar: any;
  // avatar: any;
  isCompany: boolean = false;
  isUpdating: boolean = false;
  public infoDMS: any
  public infoTrace: any;
  public nameDMS = '';
  public nameTrace = '';
  public checkDistrictBusiness: any;
  constructor(
    private _fb: FormBuilder,
    private businessService: BusinessService,
    private addressService: EvsAddressService,
    private upload: UploadService,
    private _location: Location,
    private toastr: ToastrService,
    private imageService: ImageService,
    private translate: TranslateService,
  ) {
  }


  ngOnInit() {
    console.log('123123');
    const user = JSON.parse(localStorage.getItem('User'));
    const districtBusiness = environment.districtBusiness
    console.log('user', user)
    console.log('districtBusiness', districtBusiness)
    if (user) {
      this.checkDistrictBusiness = districtBusiness.includes(user.id)
    }
    // this.getAccountSync();
    // this.getRetarget();
    var that = this;
    this.createForm();
    this.initSelect2();
    this.translate.onLangChange.subscribe(() => {
      this.initSelect2();
    });
    $('#city').on('select2:select', function (e) {
      $('.select2-selection__rendered').removeAttr('title');
      var id = e.target.value;
      $('#district').val(null).trigger('change');
      that.mDistrict = 0;
      that.businessForm.get('district').setValue(0);
      that.loadDistrictData(id);
    });
    $('#district').on('select2:select', function (e) {
      $('.select2-selection__rendered').removeAttr('title');
    });
    this.getCity();
    this.getBusiness();
  }

  initSelect2() {
    setTimeout(() => {
      $('#city').select2({
        placeholder: this.translate.instant('CHON_TINH_TP_DASH'),
        allowClear: false,
      });
      $('#district').select2({
        placeholder: this.translate.instant('CHON_QUAN_HUYEN_DASH'),
        allowClear: false,
      });
    }, 200);
  }

  async getRetarget() {
    await this.businessService.getRetarget().subscribe((res) => {
      if (res.code === 1 && res.data) {
        this.dataRetarget = res.data
        if (this.dataRetarget) {
          (<FormControl>this.reTargetForm.controls['status']).setValue(
            this.dataRetarget.status
          );
          (<FormControl>this.reTargetForm.controls['branch']).setValue(
            this.dataRetarget.branch
          );

        }
        this.startRetarget = this.dataRetarget.start;
        this.endRetarget = this.dataRetarget.end
        console.log('this.dataare', this.dataRetarget)
      }
    }, (error) => {
      this.toastr.warning(error, this.translate.instant('THAT_BAI'), {
        timeOut: 4000, positionClass: 'toast-bottom-right'
      })
    })
  }

  async getAccountSync() {
    await this.businessService.getListAccountSync().subscribe((res) => {
      if (res.code === 1 && res.data.items) {
        const result = res.data.items
        result.map((res) => {
          if (res.syncWithSystem == 1) {
            this.infoTrace = res
          } else if (res.syncWithSystem == 2) {
            this.infoDMS = res
          }
        })
        this.nameDMS = this.infoDMS.otherSystemPhone + ' - ' + this.infoDMS.otherSystemName
        this.nameTrace = this.infoTrace.otherSystemPhone + ' - ' + this.infoTrace.otherSystemName
      }
    }, (error) => {
      this.toastr.warning(error, this.translate.instant('THAT_BAI'), {
        timeOut: 4000, positionClass: 'toast-bottom-right'
      })
    })
  }

  getBusiness() {
    this.businessService.getDetailBusiness().subscribe(
      (res) => {
        if (res.code === 1) {
          this.businessForm.reset();
          this.business = res.data;
          this.getCity();
          this.isCompany = true;
          if (this.business) {
            this.mCity = this.business.city;
            this.mDistrict = this.business.district;
            (<FormControl>this.businessForm.controls['name']).setValue(
              this.business.name
            );
            (<FormControl>this.businessForm.controls['phone']).setValue(
              this.business.phone
            );
            (<FormControl>this.businessForm.controls['email']).setValue(
              this.business.email
            );
            // (<FormControl>this.businessForm.controls["website"]).setValue(
            //   this.business.website
            // );
            (<FormControl>this.businessForm.controls['city']).setValue(
              this.business.cityId
            );
            (<FormControl>this.businessForm.controls['district']).setValue(
              this.business.districtId
            );
            (<FormControl>this.businessForm.controls['address']).setValue(
              this.business.address
            );
            (<FormControl>this.businessForm.controls['tax']).setValue(
              this.business.tax
            );
            (<FormControl>this.businessForm.controls['cmt']).setValue(
              this.business.cmt
            );
            (<FormControl>this.businessForm.controls['icheckName']).setValue(
              this.business.icheckName
            );
            // this.avatar = this.imageService.readSrcImage(
            //   this.business.avatar,
            //   "thumb_medium"
            // );
            this.getAttachments();
          }
        } else {
          this.message = {
            class: 'alert dark alert-danger',
            content: res.message,
          };
          this.isCompany = false;
        }
      },
      (error) => {
        this.message = {
          class: 'alert dark alert-danger',
          content: this.translate.instant('CO_LOI_XAY_RA'),
        };
        this.isCompany = false;
      }
    );
  }

  getAttachments() {
    this.filesAttachName = [];
    if (
      this.business.attachments &&
      this.business.attachments.split(',') &&
      this.business.attachments.split(',').length > 0
    ) {
      this.business.attachments.split(',').forEach((att) => {
        var show = '';
        if (att.length > 30) {
          show = '... ... ' + att.slice(att.length - 20, att.length);
        } else {
          show = att;
        }
        var item = {
          link: att,
          show: show,
          isAdd: false,
        };
        this.filesAttachName.push(item);
      });
    }
  }

  backToComponent() {
    this._location.back();
  }

  getCity() {
    this.addressService.getCities().subscribe((res) => {
      const citiesList = [];
      res.data.cities.forEach((c: any) => {
        citiesList.push({
          value: c.name,
          label: c.name,
          id: c.id,
        });
        if (this.business) {
          if (c.id == this.business.cityId) {
            this.loadDistrictData(c.id);
          }
        }
      });
      this.cities = citiesList;
      this.initSelect2();
    });
  }

  loadDistrictData(id: number) {
    console.log('id', id)
    this.addressService
      .getDistrict({ city_id: id })
      .toPromise()
      .then((res) => {
        const districts = [];
        res.data.districts.forEach((c: any) => {
          console.log('value', id)
          districts.push({
            value: c.name,
            label: c.name,
            id: c.id,
          });
        });
        this.districts = districts;
        this.initSelect2();
        console.log('this.districts', this.districts);
      });

  }

  createForm() {
    this.businessForm = this._fb.group({
      name: [null, [Validators.required, Validators.maxLength(500)]],
      phone: [null, [Validators.maxLength(20)]],
      email: [null, [Validators.maxLength(128)]],
      city: [null],
      district: [null],
      address: [null, [Validators.required, Validators.maxLength(255)]],
      tax: [null, [Validators.maxLength(50)]],
      cmt: [null, [Validators.maxLength(50)]],
      icheckName: [null],
    });
    this.reTargetForm = this._fb.group({
      status: [null],
      branch: [null],
      start: [null],
      end: [null]
    });
  }

  scrollToTop() {
    $('html, body').animate({ scrollTop: 0 }, 'slow');
  }

  processSave() {
    this.message = {
      class: 'alert dark alert-info',
      content: this.translate.instant('DANG_THUC_THI'),
    };
  }

  onSubmit(value) {

    this.scrollToTop();
    this.isUpdating = true;
    setTimeout(() => {
      this.isUpdating = false;
    }, 2000);
    let data = value;
    let valCity = $('#city option:selected').val();
    let valDistrict = $('#district option:selected').val();
    delete data.city;
    delete data.district;
    data.city_id = valCity;
    data.district_id = valDistrict;

    //if (!data.website) delete data.website;

    if (data.name && data.name.trim() == '') {
      this.message = {
        class: 'alert alert-danger',
        content: this.translate.instant('TEN_TO_CHUC_KHONG_DE_TRONG'),
      };
      return;
    }
    if (!valCity) {
      this.message = {
        class: 'alert alert-danger',
        content: this.translate.instant('BAN_CHUA_CHON_TINH_TP'),
      };
    }
    if (!valDistrict) {
      this.message = {
        class: 'alert alert-danger',
        content: this.translate.instant('BAN_CHUA_CHON_QUAN_HUYEN'),
      };
    } else {
      this.processSave();

      if (this.files && this.files.length > 0) {
        Promise.all(
          this.files.map((file) => {
            return this.upload.upload(file).then((uploaded: any) => {
              return uploaded;
            });
          })
        ).then((upload) => {
          if (this.filesAttach.length > 0) {
            Promise.all(
              this.filesAttach.map((attach) => {
                return this.upload
                  .uploadFileAttach(attach)
                  .then((attached: any) => {
                    return attached;
                  });
              })
            ).then((attached) => {
              this.saveRecord(data, upload, attached);
            });
          } else {
            this.saveRecord(data, upload);
          }
        });
      } else {
        if (this.filesAttach.length > 0) {
          Promise.all(
            this.filesAttach.map((attach) => {
              return this.upload
                .uploadFileAttach(attach)
                .then((attached: any) => {
                  return attached;
                });
            })
          ).then((attached) => {
            this.saveRecord(data, [], attached);
          });
        } else {
          this.saveRecord(data);
        }
      }
    }
  }

  saveRecord(data, upload: any = [], attach: any = []) {
    let mBusiness = <any>{};
    mBusiness = data;
    mBusiness.name =
      mBusiness.name && mBusiness.name.trim() ? mBusiness.name.trim() : '';
    mBusiness.address =
      mBusiness.address && mBusiness.address.trim()
        ? mBusiness.address.trim()
        : '';
    mBusiness.phone =
      mBusiness.phone && mBusiness.phone.trim() ? mBusiness.phone.trim() : '';
    mBusiness.email =
      mBusiness.email && mBusiness.email.trim() ? mBusiness.email.trim() : '';
    mBusiness.tax =
      mBusiness.tax && mBusiness.tax.trim() ? mBusiness.tax.trim() : '';
    mBusiness.cmt =
      mBusiness.cmt && mBusiness.cmt.trim() ? mBusiness.cmt.trim() : '';
    mBusiness.id = this.business.id;
    // if (this.business.avatar) mBusiness.avatar = this.business.avatar;
    if (mBusiness.district_id) {
      mBusiness.districtId = mBusiness.district_id;
      delete mBusiness.district_id;
    }
    if (mBusiness.city_id) {
      mBusiness.cityId = mBusiness.city_id;
      delete mBusiness.city_id;
    }
    mBusiness.attachments = [];
    if (this.filesAttachName.length > 0) {
      for (let i = 0; i < this.filesAttachName.length; i++) {
        if (this.filesAttachName[i].isAdd == false) {
          mBusiness.attachments.push(this.filesAttachName[i].link);
        }
      }
    }
    if (attach.length > 0) {
      attach.forEach((att) => {
        mBusiness.attachments.push(att.path);
      });
    }
    // if (upload.length > 0) {
    //   mBusiness.avatar = upload[0].prefix;
    // }
    mBusiness.attachments = mBusiness.attachments.join(',');

    this.businessService
      .updateBusiness(mBusiness)
      .toPromise()
      .then(
        (res) => {
          if (res) {
            let status = res.code;
            if (status === 1) {
              this.message = {
                class: 'alert dark alert-success',
                content: this.translate.instant('CAP_NHAT_THANH_CONG'),
              };
              this.toastr.success(this.translate.instant('CAP_NHAT_THANH_CONG'), '', {
                timeOut: 4000,
                positionClass: 'toast-bottom-right',
              });
              this.filesAttach = [];
              this.getBusiness();
            } else {
              this.message = {
                class: 'alert dark alert-danger',
                // content: res.status + " : " + res.message,
                content: res.message,
              };
              this.toastr.error(res.message, '', {
                timeOut: 4000,
                positionClass: 'toast-bottom-right',
              });
            }
          }
        },
        (err) => {
          this.message = {
            content: err.message,
            class: 'alert dark alert-danger',
          };
          this.toastr.error(err.message, '', {
            timeOut: 4000,
            positionClass: 'toast-bottom-right',
          });
        }
      );
  }

  readUrl(input, placeToInsertImagePreview) {
    if (input.target.files) {
      var filesAmount = input.target.files.length;
      $(placeToInsertImagePreview).html('');
      var ValidImageTypes = [
        'image/gif',
        'image/jpeg',
        'image/png',
        'image/jpg',
      ];
      if (filesAmount <= 5) {
        for (var i = 0; i < filesAmount; i++) {
          var reader = new FileReader();
          var fileType = input.target.files[i]['type'];
          var fileName = input.target.files[i]['name'];
          var num = i + 1;
          if ($.inArray(fileType, ValidImageTypes) > 0) {
            // check is image
            // valid file type code goes here.
            reader.onload = (event: any) => {
              // this.avatar = event.target.result;
              //$(placeToInsertImagePreview).append('<li><div class="card card-shadow"><figure class="card-img-top overlay-hover overlay"><img class="overlay-figure overlay-scale" src="' + event.target.result + '" alt="..." style="height: 100px;object-fit: cover;"></figure></div></li>');
            };
            this.messageErrorImage = '';
          } else {
            this.messageErrorImage = this.translate.instant('ANH_DAI_DIEN_DINH_DANG');
          }
          reader.readAsDataURL(input.target.files[i]);
        }
      }
      // else {
      //     this.messageErrorImage = 'Bạn chỉ được chọn tối đa 5 file';
      // }
    }
  }

  readFileAttach(event) {
    //this.filesAttach = [];
    // this.getAttachments();
    var files = event.srcElement.files;
    //var listFileAttach: any = [];
    var ValidImageTypes = [
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
      'application/msword',
      'application/vnd.ms-excel',
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      'application/pdf',
      'image/gif',
      'image/jpeg',
      'image/png',
      'image/jpg',
    ];
    if (files.length > 0) {
      for (let i = 0; i < files.length; i++) {
        if (files[i]) {
          if (
            ValidImageTypes.indexOf(files[i].type) >= 0 &&
            files[i].size <= 5 * 1024 * 1024 &&
            this.filesAttachName.length < 5
          ) {
            this.filesAttach.push(files[i]);
            let filename = '';
            if (files[i].name.length > 30) {
              filename =
                files[i].name.slice(0, 20) +
                ' ... ... ' +
                files[i].name.slice(
                  files[i].name.length - 9,
                  files[i].name.length
                );
            } else {
              filename = files[i].name;
            }

            var item = {
              link: null,
              show: filename,
              name: files[i].name,
              isAdd: true,
            };
            this.filesAttachName.push(item);
          }
          if (this.filesAttachName.length >= 5) {
            this.toastr.warning(
              this.translate.instant('USER_INFO_MAX_5_FILES'),
              '',
              {
                timeOut: 4000,
                positionClass: 'toast-bottom-right',
              }
            );
            return;
          }
        }
      }
    }
  }

  onChange(event) {
    this.files = [];
    var filesAmount = event.target.files.length;
    var ValidImageTypes = ['image/gif', 'image/jpeg', 'image/png', 'image/jpg'];
    var fileType = event.target.files[0]['type'];
    var fileSize = event.target.files[0]['size'];
    if (fileSize <= 1024 * 1024) {
      if ($.inArray(fileType, ValidImageTypes) > 0) {
        for (let _file of event.target.files) {
          this.files.push(_file);
        }
      }
    } else {
      $('#fileSize').html(
        this.translate.instant('FILE_SIZE_MAX_1MB')
      );
    }
  }

  deleteFile(index) {
    var itemIndex = this.filesAttachName[index];
    var found = this.filesAttach.findIndex(function (element) {
      var index;
      if (element.name === itemIndex.name) {
        return element;
      }
    });
    //var indexFile = this.filesAttach.indexOf(found);
    this.filesAttach.splice(found, 1);
    this.filesAttachName.splice(index, 1);
  }
}



// WEBPACK FOOTER //
// /app/src/app/pages/admin/evs/business/business-profile.component.ts